'use-strict';

const formLabelAnimation = (function() {
  const focusClass = 'is-focused';
  const validClass = 'is-valid';
  /**
   *
   * @param input - input element
   */
  function toggleValidClass(input) {
    const inputContainer = input.parentNode;
    inputContainer.classList.remove(focusClass);
    return input.value !== ''
      ? inputContainer.classList.add(validClass)
      : inputContainer.classList.remove(validClass);
  }
  /**
   *
   * @param e - event
   */
  function classToggleHandler(e) {
    const input = e.currentTarget;
    const inputContainer = input.parentNode;
    if (e.type === 'focus') {
      inputContainer.classList.add(focusClass);
    } else if (e.type === 'blur') {
      toggleValidClass(input);
    }
  }
  function init() {
    const inputTarget = '.js-form-label-animation';
    const formInputs = document.querySelectorAll(
      `${inputTarget} input[type="text"],
       ${inputTarget} input[type="email"],
       ${inputTarget} input[type="phone"],
       ${inputTarget} select`
    );
    [...formInputs].forEach(input => {
      toggleValidClass(input);
      input.addEventListener('focus', function(e) {
        classToggleHandler(e);
      });
      input.addEventListener('blur', function(e) {
        classToggleHandler(e);
      });
    });
  }
  return {
    init,
    toggleValidClass,
  };
})();
export default formLabelAnimation;
